export enum TrainingAudience {
  "All" = "ALL",
  "Leadership" = "LEADERSHIP",
}

export enum DeliveryMethod {
  "LMS" = "LMS",
  "Link" = "LINK",
}

export interface TrainingModuleResponse {
  assets: AssetResponse[];
  audience_type: TrainingAudience;
  can_access: boolean;
  can_view: boolean;
  delivery_method: DeliveryMethod;
  description: string;
  duration: string;
  is_ready: boolean;
  languages: string[];
  reference_id: string;
  suggested_order?: number;
  tags: string[];
  title: string;
  touchpoints: TouchpointResponse[];
}

export interface AssetResponse {
  language: string;
  id: string;
  type: string;
}

export interface TouchpointResponse {
  description: string;
  duration: string;
  order: number;
  preview_link: string;
  direct_link: string;
  reference_id: string;
  thumbnail: string;
  title: string;
}

export enum AssetTypeEnum {
  Toolbox = "Toolbox",
  Thumbnail = "Thumbnail",
}

export interface TouchpointInfo {
  reference_id: string;
  title: string;
  description: string;
  training_module: {
    reference_id: string;
    title: string;
  };
}

export interface TrainingCompletionResponse {
  learner_id: string;
  touchpoint_info: TouchpointInfo;
  completion_status: string;
  completed_date: string;
  last_access_date: string;
}
